import type { SectionDef } from './TabRenderer';
import { ConditionsHero, ConditionsExplainer, ConditionsBody } from './ConditionsSections';
import { MedicationsHero, MedicationsExplainer, MedicationsBody } from './MedicationsSections';
import { TrendsHero, TrendsExplainer, TrendsBody } from './TrendsSections';
import { EncountersHero, EncountersExplainer, EncountersBody } from './EncountersSections';
import { ProceduresHero, ProceduresExplainer, ProceduresBody } from './ProceduresSections';
import { NotesHero, NotesExplainer, NotesBody } from './NotesSections';
import { MyDocumentsHero, MyDocumentsExplainer, MyDocumentsBody } from './MyDocumentsSections';
import { ObservationsHero, ObservationsExplainer, ObservationsBody } from './ObservationsSections';
import { AllergiesHero, AllergiesExplainer, AllergiesBody } from './AllergiesSections';
import { UpcomingHero, UpcomingBody } from './UpcomingSections';

// ============================================================================
// Tab → sections registry (the config that drives TabRenderer). Common
// sections get defined once and referenced from multiple tab arrays; order in
// the array = render order. Tabs NOT listed here fall back to the legacy
// rendering inside HWRecordRendererV1 (redesign proceeds tab by tab —
// Conditions first, per Leo).
// ============================================================================

export const TAB_SECTIONS: Record<string, SectionDef[]> = {
  conditions: [
    { key: 'hero', Component: ConditionsHero },
    { key: 'explainer', Component: ConditionsExplainer },
    { key: 'body', Component: ConditionsBody },
  ],
  medications: [
    { key: 'hero', Component: MedicationsHero },
    { key: 'explainer', Component: MedicationsExplainer },
    { key: 'body', Component: MedicationsBody },
  ],
  trends: [
    { key: 'hero', Component: TrendsHero },
    { key: 'explainer', Component: TrendsExplainer },
    { key: 'body', Component: TrendsBody },
  ],
  encounters: [
    { key: 'hero', Component: EncountersHero },
    { key: 'explainer', Component: EncountersExplainer },
    { key: 'body', Component: EncountersBody },
  ],
  procedures: [
    { key: 'hero', Component: ProceduresHero },
    { key: 'explainer', Component: ProceduresExplainer },
    { key: 'body', Component: ProceduresBody },
  ],
  notes: [
    { key: 'hero', Component: NotesHero },
    { key: 'explainer', Component: NotesExplainer },
    { key: 'body', Component: NotesBody },
  ],
  mydocuments: [
    { key: 'hero', Component: MyDocumentsHero },
    { key: 'explainer', Component: MyDocumentsExplainer },
    { key: 'body', Component: MyDocumentsBody },
  ],
  observations: [
    { key: 'hero', Component: ObservationsHero },
    { key: 'explainer', Component: ObservationsExplainer },
    { key: 'body', Component: ObservationsBody },
  ],
  allergies: [
    { key: 'hero', Component: AllergiesHero },
    { key: 'explainer', Component: AllergiesExplainer },
    { key: 'body', Component: AllergiesBody },
  ],
  upcoming: [
    { key: 'hero', Component: UpcomingHero },
    { key: 'body', Component: UpcomingBody },
  ],
};
